import React from 'react'
import { Box, Typography, SxProps, Theme } from '@mui/material'
import StarIcon from '@mui/icons-material/Star'
import { JackpotInfo, PrizesInfo } from 'types/types'

interface PrizeJackpotSectionProps {
  prizes?: PrizesInfo | null
  jackpot?: JackpotInfo | null
  fallbackPrize?: string | null
  fallbackPrizeLabel?: string
  sx?: SxProps<Theme>
}

function PrizeJackpotSection({
  prizes,
  jackpot,
  fallbackPrize,
  fallbackPrizeLabel = 'Prize pool',
  sx,
}: PrizeJackpotSectionProps) {
  const primaryColor = '#FFC107'
  const textColor = '#353535'
  const hasJackpot = jackpot?.amount && jackpot?.requirements
  const firstPrize = prizes?.prizes?.[0]

  // Use structured prize if available, otherwise fall back to simple string
  const prizeLabel = firstPrize?.label || fallbackPrizeLabel
  const prizeValue = firstPrize?.value || fallbackPrize

  const hasPrize = !!prizeValue

  // Don't render anything if there's no prize and no jackpot
  if (!hasPrize && !hasJackpot) {
    return null
  }

  return (
    <Box
      sx={{
        background: '#FFF3CD',
        p: 2,
        ...sx,
      }}
    >
      {hasJackpot && (
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
            <StarIcon sx={{ fontSize: 25, color: primaryColor }} />

            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 700,
                color: textColor,
              }}
            >
              Jackpot
            </Typography>

            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 800,
                color: textColor,
                ml: 'auto',
              }}
            >
              {jackpot.amount}
            </Typography>
          </Box>

          <Typography
            sx={{
              fontSize: 12,
              color: 'rgba(120, 120, 120, 0.9)',
            }}
          >
            {jackpot.requirements}
          </Typography>
        </Box>
      )}

      {hasPrize && (
        <Box>
          {hasJackpot && <Box sx={{ borderTop: `1px solid #F1D88A`, mb: 0, mt: 1.5 }} />}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mt: hasJackpot ? 1.5 : 0,
            }}
          >
            <Typography sx={{ fontSize: 16, color: textColor }}>{prizeLabel}</Typography>

            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 700,
                color: textColor,
              }}
            >
              {prizeValue}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default PrizeJackpotSection
